import * as z from 'zod';

import { registrarQuerySchema } from './registrar-query-schema';

export const registrarUpdateSchema = registrarQuerySchema
  .pick({
    id: true,
    name: true,
  })
  .extend({
    url: z.url(),
    notes: z.string(),
    logo: z.array(z.number()).nullish(),
    phone_numbers: z.array(z.number()).nullish(),
    domains: z.array(z.number()),
  });
export type RegistrarUpdateSchema = z.infer<typeof registrarUpdateSchema>;

export const registrarCreateSchema = registrarUpdateSchema.omit({ id: true, domains: true });
export type RegistrarCreateSchema = z.infer<typeof registrarCreateSchema>;
